import React from "react";
import { Link } from 'react-router-dom';
import axios from 'axios';
import { loginUser } from "~/shared/auth-utils";
import TextInput from "~/shared/form/TextInput";
import ControlledForm from "~/shared/form/ControlledForm";
import FormResponse from "~/shared/form/FormResponse";
import FormButton from "~/shared/form/FormButton";
import PublicPage from "./PublicPage";

export default function FamilyRegistration() {
    async function onSubmit(data) {
        const profile = await axios.post("auth/register-family", data);
        loginUser(profile.data.token);
    }

    return (
        <PublicPage title="Family Portal" documentTitle="Register" heading="Register">
            <ControlledForm className="flex flex-col" onSubmit={onSubmit} redirect="/" noAsterisk>
                <p className="text-neutral-600 mb-4">Enter your information below to create a new account.</p>
                <div className="flex flex-col gap-4">
                    <TextInput label="Email Address" id="email" placeholder="Enter email address" preset="email" required />
                    <TextInput label="Password" id="password" placeholder="Enter password" validate={(password, { confirm }) => password === confirm} invalid="Passwords must match." deps="confirm" preset="password" required>
                        <span className="text-neutral-600 text-sm text-left mt-1">Password must be at least 8 characters long.</span>
                    </TextInput>
                    <TextInput label="Confirm Password" id="confirm" errorLabel="password confirmation" placeholder="Confirm password" validate={(confirm, { password }) => password === confirm} invalid="Passwords must match." deps="password" preset="password" required />
                </div>
                <p className="mt-4 text-sm text-neutral-600">By registering, you agree to our <Link to="/privacy" className="red-link">Privacy Policy</Link>.</p>
                <FormResponse />
                <div className="flex flex-col gap-4 items-center mt-2">
                    <FormButton submit>Register</FormButton>
                    <Link to="/family-portal" className="red-link">Already have an account?</Link>
                </div>
            </ControlledForm>
        </PublicPage>
    );
}
